interface AttentionWorkOrder {
    status?: { value?: string | null } | null;
}

/**
 * A work order "needs attention" (and gets the red "Attention Required" banner) only while it is in
 * the backend draft status. Unassigned work orders past draft are flagged solely by the red
 * "Unassigned" label on the card, not the banner.
 */
export const workOrderNeedsAttention = (workOrder: AttentionWorkOrder | null | undefined): boolean => {
    return workOrder?.status?.value === 'draft';
};
